import ApiService from "../../common/apiService";
import { getData } from "../../common/dataHelper";
import { COURSE_TYPES } from "../types";
const state = {
    courses: [],
    course: {},
    selectedCourseType: null, // targetAgreement, slide, manual, feedback,certificate
    showDocuments: false,
};

const getters = {
    [COURSE_TYPES.GET_COURSES](state) {
        return state.courses;
    },
    [COURSE_TYPES.GET_COURSE](state) {
        return state.course;
    },
    [COURSE_TYPES.GET_SELECTED_COURSE_TYPE](state) {
        return state.selectedCourseType;
    },
    [COURSE_TYPES.GET_SHOW_DOCUMENTS](state) {
        return state.showDocuments;
    },
};

const actions = {
    async [COURSE_TYPES.FETCH_COURSES]({ commit }) {
        const response = await ApiService.query("academy/courses");
        const courses = getData(response, "data.courses");
        if (courses) {
            commit(COURSE_TYPES.SET_COURSES, courses);
        }
        return response;
    },
    async [COURSE_TYPES.FETCH_COURSE]({ commit }, { courseId }) {
        const response = await ApiService.get("academy/courses", courseId);
        const course = getData(response, "data.course");
        if (course) {
            commit(COURSE_TYPES.SET_COURSE, course);
        }
        return response;
    },
    // type targetAgreement, feedback
    async [COURSE_TYPES.VALIDATE_REVIEW]({ state }, { type }) {
        const course = state.course;
        const courseId = getData(course, "id");
        const response = await ApiService.query(
            `academy/courses/${courseId}/${
                type == "targetAgreement"
                    ? "checkTargetAgreement"
                    : "checkFeedback"
            }`
        );

        return response;
    },
    async [COURSE_TYPES.UPDATE_CUSTOMER_REVIEWS](
        { state, rootState },
        { review }
    ) {
        const course = state.course;
        // if(course.isDemoZugang){
        // return;
        // }
        const customer = rootState.authUser.user;
        const customerReview = review.customerReviews[0];
        const courseId = getData(course, "id");
        const response = await ApiService.put(
            `academy/reviews/${review.id}/customerReviews/${customerReview.id}`,
            {
                course: { id: courseId },
                answer: customerReview.answer,
                customerOptions: customerReview.customerOptions,
                customer,
            }
        );

        return response;
    },
    async [COURSE_TYPES.UPLOAD_COURSE_WORKBOOK](
        { rootState, state },
        { file }
    ) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("model_name", "Customer");
        formData.append("model_id", getData(rootState, "authUser.user.id"));
        formData.append("related_model_name", "course");
        formData.append("related_model_id", getData(state, "course.id"));
        formData.append("collection", "workbook");

        const response = await ApiService.post(`academy/media`, formData);
        const newMedia = getData(response, "data.medium");
        if (newMedia) {
            state.course.materials.push(newMedia);
        }

        return response;
    },
     async [COURSE_TYPES.UPLOAD_DOCUMENT](
        { rootState},
        { file }
    ) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("model_name", "Customer");
        formData.append("model_id", getData(rootState, "authUser.user.id"));
        formData.append("related_model_name", "course");
        formData.append("related_model_id", "");
        formData.append("collection", "workbook");

        const response = await ApiService.post(`academy/media`, formData);
        //const newMedia = getData(response, "data.medium");


        return response;
    },
};

const mutations = {
    [COURSE_TYPES.SET_COURSES](state, array) {
        state.courses = array;
    },
    [COURSE_TYPES.SET_COURSE](state, object) {
        state.course = object;
    },
    [COURSE_TYPES.SET_SELECTED_COURSE_TYPE](state, payload) {
        state.selectedCourseType = payload;
    },
    [COURSE_TYPES.SET_SHOW_DOCUMENTS](state, bool) {
        state.showDocuments = bool;
    },
    [COURSE_TYPES.RESET_STATE](state) {
        state.selectedCourseType = null;
        state.showDocuments = false;
        state.courses = [];
        state.course = {};
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
